import React from "react"
import {Link} from "gatsby"
import { SocialIcon } from 'react-social-icons';

export default function Footer(props) {

  return (
    <footer >
      <div>© {new Date().getFullYear()}, Built by
      {` `}
      <a href="https://github.com/emseely">Emma S-K</a></div>

     <SocialIcon style={{ height: 30, width: 30 }} id = "svgIcon" url="http://instagram.com/mold_fashioned" bgColor="#3db931"/>
    </footer>
  )
}
